/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const prefix = 'auto-scale';

export const autoScalePolicyModalBreadcrumbTitle = `${prefix}.autoScalePolicyModalBreadcrumbTitle`;
export const scheduledScalingModalBreadcrumbTitle = `${prefix}.scheduledScalingModalBreadcrumbTitle`;

export const ENGLISH = {
    [autoScalePolicyModalBreadcrumbTitle]: 'Server AutoScale Policy',
    [scheduledScalingModalBreadcrumbTitle]: 'Scheduler',
};
